import { withAuthGuard } from '@/hoc/withAuthGuard';
import { usePageTitle } from '@/hooks/usePageTitle';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

interface AccountProps {}

const AccountComponent: FC<AccountProps> = () => {
  usePageTitle('account');

  return <Outlet />;
};

const Account = withAuthGuard('protected')(AccountComponent);

export default Account;
